import React from 'react';

interface LessonNavigationProps {
  hasPreviousLesson: boolean;
  hasNextLesson: boolean;
  onPrevious: () => void;
  onNext: () => void;
  isNextDisabled?: boolean;
  nextDisabledMessage?: string;
  variant?: 'blue' | 'emerald';
}

export const LessonNavigation: React.FC<LessonNavigationProps> = ({
  hasPreviousLesson,
  hasNextLesson,
  onPrevious,
  onNext,
  isNextDisabled = false,
  nextDisabledMessage,
  variant = 'blue',
}) => {
  const accent = variant === 'emerald'
    ? {
        enabled: 'bg-emerald-600 hover:bg-emerald-700 text-white',
        disabled: 'bg-slate-200 text-slate-400 cursor-not-allowed',
        outline: 'border-slate-200 text-slate-700 hover:bg-slate-50',
      }
    : {
        enabled: 'bg-blue-600 hover:bg-blue-700 text-white',
        disabled: 'bg-slate-200 text-slate-400 cursor-not-allowed',
        outline: 'border-slate-200 text-slate-700 hover:bg-slate-50',
      };

  return (
    <div className="mt-8 pt-6 border-t border-slate-200">
      <div className="flex items-center justify-between gap-4">
        <button
          onClick={onPrevious}
          disabled={!hasPreviousLesson}
          className={`flex items-center gap-2 px-5 py-2.5 rounded-xl font-semibold border transition-colors ${
            hasPreviousLesson ? accent.outline : 'border-slate-100 text-slate-300 cursor-not-allowed'
          }`}
        >
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
          </svg>
          السابق
        </button>

        <button
          onClick={onNext}
          disabled={!hasNextLesson || isNextDisabled}
          className={`flex items-center gap-2 px-5 py-2.5 rounded-xl font-semibold transition-colors ${
            hasNextLesson && !isNextDisabled ? accent.enabled : accent.disabled
          }`}
        >
          التالي
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
          </svg>
        </button>
      </div>

      {isNextDisabled && hasNextLesson && nextDisabledMessage && (
        <p className="mt-3 text-center text-sm text-orange-600 font-medium">
          {nextDisabledMessage}
        </p>
      )}
    </div>
  );
};
